import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from '../../config/urls';

const generalEndpoints = {
    getCities: (uf = 'all') => stipAxios.get(`/guest/${uf}/municipios`),
    getPolos: () => stipAxios.get(`/guest/polos`),
    getDocumentTypes: () => stipAxios.get(`/tipo-documento/find-all-termos`),
    getDocumentTypesLine: () => stipAxios.get(`/tipo-documento/find-all-tipos-linha`),
    getOrgaos: () => stipAxios.get(`/orgao/all`),
    getOrgaoDefault: () => stipAxios.get(`/orgao/padrao`),
    getIndecxExternalKey: () => stipAxios.get(`${EXTERNAL_CONTEXT}/pesquisa-satisfacao/external-key`),
    getIndecxKey: () => stipAxios.get(`${EXTERNAL_CONTEXT}/pesquisa-satisfacao/key`),
};

export default generalEndpoints;
